(() => {
  function initialise(root) {
    if (root.dataset.vpaReady) return;
    root.dataset.vpaReady = 'true';
    const wallIcon = root.querySelector('.vpa-wall-action #ar-button-icon');
    const wallEye = root.querySelector('[data-vpa-wall-eye]');
    if (wallIcon && wallEye) wallIcon.replaceChildren(wallEye.content.cloneNode(true));
    const section = root.dataset.section;
    const bar = root.querySelector('[data-vpa-sticky]');
    if (!bar) return;
    const variants = JSON.parse(bar.querySelector('[data-vpa-variants]').textContent);
    const messages = JSON.parse(bar.querySelector('[data-vpa-messages]').textContent);
    const buy = bar.querySelector('[data-vpa-buy]');
    const label = bar.querySelector('[data-vpa-buy-label]');
    const selection = bar.querySelector('[data-vpa-selection]');
    const form = () => root.querySelector(`#product-form-${section}`);
    const submit = () => form()?.querySelector('[name="add"]');
    function sync() {
      const id = form()?.querySelector('[name="id"]')?.value;
      const variant = variants.find(item => String(item.id) === id);
      const source = submit();
      const quantity = root.querySelector('.quantity__input')?.value || '1';
      buy.disabled = !variant || !variant.available || !source || source.disabled || source.getAttribute('aria-disabled') === 'true';
      buy.classList.toggle('loading', !!source?.classList.contains('loading'));
      if (!variant) { label.textContent = messages.unavailable; return; }
      const price = root.querySelector(`#price-${section} .price__sale .price-item--sale`)?.textContent?.trim();
      const regular = root.querySelector(`#price-${section} .price__regular .price-item--regular`)?.textContent?.trim();
      const onSale = root.querySelector(`#price-${section} .price`)?.classList.contains('price--on-sale');
      label.textContent = `${(onSale ? price : regular) || regular || price} · ${variant.title} · ${variant.available ? messages.add : messages.sold}`;
      selection.textContent = `${variant.title} · ${messages.quantity} ${quantity}`;
      const dimensions = {A4:'21 × 29.7cm',A3:'29.7 × 42cm',A2:'42 × 59.4cm',A1:'59.4 × 84.1cm',A0:'84.1 × 118.9cm','50 × 70cm':'50 × 70cm','70 × 100cm':'70 × 100cm','50 x 70cm':'50 × 70cm','70 x 100cm':'70 × 100cm'};
      const size = variant.options.find(option => dimensions[option]);
      const note = root.querySelector('[data-vpa-paper-size]');
      if (note) { note.hidden = !size; const text = size ? note.dataset.label.replace('[size]', `${size}: ${dimensions[size]}`) : ''; if (note.textContent !== text) note.textContent = text; }
    }
    buy.addEventListener('click', () => { const source = submit(); if (source && !source.disabled) source.click(); });
    root.addEventListener('change', sync);
    root.addEventListener('input', sync);
    root.addEventListener('click', event => {
      const toggle = event.target.closest('[data-vpa-read-more]');
      if (toggle) {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        root.querySelector(`#${toggle.getAttribute('aria-controls')}`).classList.toggle('vpa-description-preview', !expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
      }
      const link = event.target.closest('[data-vpa-open-details]');
      if (link) root.querySelector(link.getAttribute('href')).open = true;
    });
    const info = root.querySelector(`#ProductInfo-${section}`);
    new MutationObserver(sync).observe(info, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','value','class']});
    sync();
  }
  let previewFrame;
  let previewResize;
  let previewScheduled = false;
  function positionPurchaseBar() {
    previewScheduled = false;
    const frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    if (frame !== previewFrame) {
      previewResize?.disconnect();
      previewFrame = frame;
      if (frame) { previewResize = new ResizeObserver(schedulePreviewPosition); previewResize.observe(frame); }
    }
    const bounds = frame?.getBoundingClientRect();
    const visible = frame && getComputedStyle(frame).display !== 'none' && getComputedStyle(frame).visibility !== 'hidden' && bounds.height > 0 && bounds.height < window.innerHeight / 2;
    const offset = visible ? Math.max(0, window.innerHeight - bounds.top) : 0;
    document.documentElement.style.setProperty('--vpa-preview-offset', `${Math.ceil(offset)}px`);
  }
  function schedulePreviewPosition() {
    if (!previewScheduled) { previewScheduled = true; requestAnimationFrame(positionPurchaseBar); }
  }
  new MutationObserver(schedulePreviewPosition).observe(document.body, {childList:true});
  window.addEventListener('resize', schedulePreviewPosition);
  document.addEventListener('toggle', schedulePreviewPosition, true);
  schedulePreviewPosition();
  document.querySelectorAll('product-info').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('product-info').forEach(initialise));
})();
